<ng-container>
  <div class="flex w-full h-full flex-col justify-start">
    <header class="shrink-0 grow-0">
      <gx-button
        (click)="onCloseButtonClicked()"
        hasIcon="only"
        icon="close"
        text="{{'Close' | translate}}"
        title="{{'Close' | translate}}"
        variant="neutral"
        data-testid="detail-view-close-button" />
    </header>

    <div class="grow">
      <div id="map"></div>
    </div>
  </div>
</ng-container>
